import React, { useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import { formatColombianDate, parseColombianDate } from '../lib/demoAccount.mjs';

// Opt-in civil-date input. Its caller selects the demo variant; no global date
// input or browser locale is changed. Partial/invalid drafts never become dates.
export default function ColombianDateField({ value, onChangeValue, ...props }) {
  const display = (iso) => iso ? formatColombianDate(iso) : '';
  const [draft, setDraft] = useState(() => display(value));
  const sent = useRef(value || '');
  useEffect(() => {
    if ((value || '') !== sent.current) {
      sent.current = value || '';
      setDraft(display(value));
    }
  }, [value]);
  const invalid = draft !== '' && !parseColombianDate(draft);
  return <TextField {...props} type="text" value={draft} placeholder="dd/mm/aaaa"
    inputProps={{ inputMode: 'numeric', maxLength: 10, 'aria-label': props.label || 'Fecha (dd/mm/aaaa)' }}
    error={invalid} helperText={invalid ? 'Escribe una fecha válida: dd/mm/aaaa.' : props.helperText}
    onChange={(event) => {
      setDraft(event.target.value);
      sent.current = parseColombianDate(event.target.value);
      onChangeValue(sent.current);
    }} />;
}
